import loadLinkPreview from './linkPreview';
import { protectExternalLink } from './externalLinkPolicy';
function isStandaloneUrl(anchor) {
  const paragraph = anchor.parentElement;
  const label = anchor.textContent.trim();
  if (!paragraph || paragraph.tagName !== 'P' || paragraph.textContent.trim() !== label) return false;
  return /^https?:\/\//i.test(label) && label.replace(/\/$/, '') === anchor.href.replace(/\/$/, '');
}
function createText(tag, className, text) {
  const element = document.createElement(tag);
  element.className = className;
  element.textContent = text;
  return element;
}
function createCard(preview) {
  const card = document.createElement('a');
  const target = new URL(preview.url);
  const mark = createText('span', 'dc-link-card__mark', preview.internal ? '</>' : target.hostname.slice(0, 1).toUpperCase());
  const body = document.createElement('span');
  card.className = `dc-link-card${preview.internal ? ' dc-link-card--internal' : ''}`;
  card.href = preview.url;
  card.append(mark, body, createText('span', 'dc-link-card__arrow', '↗'));
  body.className = 'dc-link-card__body';
  body.append(createText('small', 'dc-link-card__site', preview.siteName), createText('strong', 'dc-link-card__title', preview.title));
  if (preview.description) {
    body.append(createText('span', 'dc-link-card__description', preview.description));
  }
  protectExternalLink(card);
  return card;
}
export default function enhancePostLinks(root, configuredLimit) {
  if (configuredLimit === void 0) {
    configuredLimit = 3;
  }
  if (!root) return;
  const links = Array.from(root.querySelectorAll('a[href]'));
  // Сервер задаёт административный предел, а браузер повторно ограничивает его безопасным диапазоном.
  const cardLimit = Math.max(1, Math.min(6, Number.parseInt(configuredLimit, 10) || 3));
  links.forEach(protectExternalLink);
  links.filter(link => link.dataset.dcPreviewState === undefined && isStandaloneUrl(link)).slice(0, cardLimit).forEach(link => {
    link.dataset.dcPreviewState = 'loading';
    loadLinkPreview(link.href).then(preview => {
      if (!preview || !link.isConnected || link.dataset.dcPreviewState === 'ready') return;
      const paragraph = link.parentElement;
      const card = createCard(preview);
      paragraph.insertAdjacentElement('afterend', card);
      paragraph.classList.add('dc-link-source--enhanced');
      link.dataset.dcPreviewState = 'ready';
    });
  });
}
flarum.reg.add('devconnect-link-cards', 'forum/service/postLinkEnhancer', enhancePostLinks);
flarum.reg.add('devconnect-link-cards', 'forum/service/postLinkEnhancer', enhancePostLinks);